import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router";

import {
  toggleModal,
  selectedReport,
} from "app/store/transmission/slice/transmissionSlice";

import TransmissionModals from "../TransmissionModals";
import { getRedirectPath } from "utils/routes.util";

const TransmissionReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { reportId } = useParams();

  const { isReportDetailModal } = useSelector((state) => state.transmission);

  useEffect(() => {
    if (!reportId) {
      const redirectPath = getRedirectPath();
      navigate(redirectPath, { replace: true });
      return;
    }

    dispatch(
      selectedReport({
        id: reportId,
        isLegacyReport: true,
        reportDetail: { _id: reportId },
      })
    );

    dispatch(toggleModal({ type: "reportDetail", value: true }));
  }, [reportId]);

  if (!isReportDetailModal) return null;

  return <TransmissionModals />;
};

export default TransmissionReport;
